import memberRequest from './memberRequest';
import { MEMBER_API } from '../constants/endpoints';

/**
 * 充值 / 提款 / 流水 — 走 MEMBER_API BFF。
 * 會員身份由 Token 解析，前端不傳 memberId。
 */
export const paymentApi = {
  depositPage: (params) =>
    memberRequest.get(`${MEMBER_API}/deposit/page`, { params }),

  createOnlineDeposit: (data) =>
    memberRequest.post(`${MEMBER_API}/deposit/online/create`, data),

  submitOfflineDeposit: (data) =>
    memberRequest.post(`${MEMBER_API}/deposit/offline`, data),

  withdrawOrder: (data) =>
    memberRequest.post(`${MEMBER_API}/withdraw/order`, data, {
      headers: { lang: 'zh-TW' },
    }),

  withdrawPage: (params) =>
    memberRequest.get(`${MEMBER_API}/withdraw/page`, { params }),

  bindWithdrawAddress: (data) =>
    memberRequest.post(`${MEMBER_API}/withdraw/bind-address`, data),

  listWithdrawAddresses: () =>
    memberRequest.get(`${MEMBER_API}/withdraw/all-bind-address`),

  listWithdrawChannelOptions: (params) =>
    memberRequest.get(`${MEMBER_API}/coinPayType/withdraw/options`, {
      params: params || undefined,
    }),

  listWithdrawMethodCategories: () =>
    memberRequest.get(`${MEMBER_API}/coinPayType/withdraw/method-categories`),

  unbindWithdrawAddress: (data) =>
    memberRequest.post(`${MEMBER_API}/withdraw/del-withdraw-address`, data),

  transactionPage: (params) =>
    memberRequest.get(`${MEMBER_API}/memberTransaction/page`, { params }),

  listDepositMerchants: (params) =>
    memberRequest.get(`${MEMBER_API}/deposit/merchants`, { params }),

  listOnlineDepositChannels: (params) =>
    memberRequest.get(`${MEMBER_API}/deposit/online/channels`, { params }),

  listOfflineDepositAddresses: () =>
    memberRequest.get(`${MEMBER_API}/deposit/offline/addresses`),

  getOfflineDepositAddress: (params) =>
    memberRequest.get(`${MEMBER_API}/deposit/offline/address`, { params }),
};
